import React from 'react';
import Select from '../form/Select';
import FormsySimpleInput from '../form/FormsySimpleInput';

const DishHeading = (props) => {
  const {
    dish,
    onChange,
    onSelectChange,
    availableSeasonality,
    availableCuisines,
    handleMaster,
    isMutable = false,
    isEdit = false,
  } = props;

  if (isEdit)
    return renderEdit(
      dish,
      onChange,
      onSelectChange,
      availableSeasonality,
      availableCuisines,
      isMutable,
      handleMaster
    );
  else return renderView(dish, isMutable, handleMaster);
};

const renderEdit = (
  dish,
  onChange,
  onSelectChange,
  availableSeasonality,
  availableCuisines,
  isMutable,
  handleMaster
) => {
  const child =
    'parent_dish_id' in dish && dish.parent_dish_id ? (
      <div className="row__item row__item--half row__item--pad">
        <h2 className="dish-edit__label dish-edit__label--margin-bot">
          Child Dish Name
        </h2>
        {isMutable ? (
          <p
            className="dish-heading__link dish-heading__link--right"
            onClick={handleMaster}
          >
            Make Master
          </p>
        ) : (
          ''
        )}
        <FormsySimpleInput
          type="text"
          name="child_name"
          placeholder="Child Dish Name"
          required
          value={dish.child_name || ''}
          onChange={onChange}
          autoComplete="off"
        />
      </div>
    ) : (
      ''
    );
  let complexityOptions = [
    { value: 'basic', label: 'Basic' },
    { value: 'simple', label: 'Simple' },
    { value: 'moderate', label: 'Moderate' },
    { value: 'intensive', label: 'Intensive' },
  ];

  let seasonalityOptions = availableSeasonality.map((item) => {
    return { value: item.id, label: item.tag };
  });

  let cuisineOptions = availableCuisines.map((item) => {
    return { value: item.id, label: item.name };
  });

  return (
    <div className="cms__bar-inputs">
      <div className="dish-heading row">
        <div className="row__item row__item--third row__item--pad-right">
          <h2 className="dish-edit__label dish-edit__label--margin-bot">
            Dish Name
          </h2>
          <FormsySimpleInput
            type="text"
            name="name"
            placeholder="Dish Name"
            required
            value={dish.name || ''}
            onChange={onChange}
            autoComplete="off"
          />
        </div>
        <div className="row__item row__item--third row__item--pad-right">
          <h2 className="dish-edit__label dish-edit__label--margin-bot">
            Complexity
          </h2>
          <Select
            name="complexity"
            placeholder="Complexity"
            value={dish.complexity}
            options={complexityOptions}
            onChange={(value) => onSelectChange('complexity', value)}
          />
        </div>
        <div className="row__item row__item--third row__item--pad-right">
          <h2 className="dish-edit__label dish-edit__label--margin-bot">
            Seasonality
          </h2>
          <Select
            name="seasonality"
            placeholder="Seasonality"
            isMulti
            value={dish.seasonalities ? dish.seasonalities.map(seasonality => ({ value: seasonality.id, label: seasonality.name })) : []}
            options={seasonalityOptions}
            onChange={(choices) => {
              let seasons = choices.map(choice => ({ id: choice.value, name: choice.label}))
              onSelectChange('seasonalities', seasons, true );
            }}
          />
        </div>
        <div className="row__item row__item--half row__item--pad-right">
          <h2 className="dish-edit__label dish-edit__label--margin-bot">
            Cuisine
          </h2>
          <Select
            name="cuisines"
            placeholder="Cuisine"
            isMulti
            value={dish.cuisines ? dish.cuisines.map(cuisine => ({ value: cuisine.id, label: cuisine.name })) : []}
            options={cuisineOptions}
            onChange={(choices) => {
              let cuisines = choices.map(choice => ({ id: choice.value, name: choice.label}))
              onSelectChange('cuisines', cuisines, true);
            }}
          />
        </div>
        {child}
      </div>
    </div>
  );
};

const renderView = (dish, isMutable, handleMaster) => {
  let contents = '';
  if (dish.name && !dish.child_name) {
    contents = (
      <div className="dish-heading">
        <p className="dish-heading__label">Dish Name</p>
        <h1 className="dish-heading__heading">{dish.name}</h1>
      </div>
    );
  } else if (dish.name) {
    contents = (
      <div className="dish-heading">
        <p className="dish-heading__label">Dish Name</p>
        {isMutable ? (
          <p className="dish-heading__link" onClick={handleMaster}>
            Make Master
          </p>
        ) : (
          ''
        )}
        <h1 className="dish-heading__heading">{dish.name}</h1>
        <p className="dish-heading__subheading">{dish.child_name}</p>
      </div>
    );
  } else
    contents = (
      <div className="dish-heading">
        <h1 className="dish-heading__placeholder">Dish Name</h1>
      </div>
    );

  return <div className="cms__bar-item">{contents}</div>;
};

export default DishHeading;



// WEBPACK FOOTER //
// ./src/components/dish/DishHeading.js